export default __webpack_public_path__ + "static/media/Barefeet-5.c8028578.png";